import { RegionTypes } from '../constants/regionType';
import { RegionService } from '../services/regionService';

const regionService = new RegionService();
const IS_SA = regionService.currentRegion() === RegionTypes.SaudiArabia;
const DATALAB_API_KEY = "MTf0eUf1QJyegkhIRFDq7krRuDOeETDvMgy-Bnf8Nz0";
const API_KEY = IS_SA
	? process.env.REACT_APP_API_URL_SA
	: process.env.REACT_APP_API_URL;
const CYNOPSIS_URL = process.env.REACT_APP_CYNOPSIS_URL;
const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;
const CURRENCY = IS_SA
	? process.env.REACT_APP_CURRENCY_SA
	: process.env.REACT_APP_CURRENCY;

const IS_PROD = process.env.REACT_APP_ENV === 'prod';
const TINY_MCE_TOKEN = IS_SA ? process.env.REACT_APP_TINY_MCE_TOKEN_SA : process.env.REACT_APP_TINY_MCE_TOKEN;
const IDWISE_CLIENT_ID = '008953cd-bdfb-401f-b926-b09ab3ecaa30';
const IDWISE_BUSINESS_ID = 'e2e16653-ab51-4472-83aa-a2cf87f11cd6';
const idwiseUrl = (id) => `https://idwise.studio/journey-details/${IDWISE_CLIENT_ID}/${id}/overview?businessId=${IDWISE_BUSINESS_ID}&tenantId=${IDWISE_CLIENT_ID}`;
const IS_DEV = process.env.REACT_APP_ENV_TEST === 'dev';
const IS_MCP_ENABLED = process.env.REACT_APP_IS_MCP_ENABLED === 'true';

export {
	API_KEY,
	CYNOPSIS_URL,
	WEBSITE_URL,
	CURRENCY,
	IS_SA,
	IS_PROD,
	TINY_MCE_TOKEN,
	IDWISE_CLIENT_ID,
	IDWISE_BUSINESS_ID,
	idwiseUrl,
	IS_DEV,
	DATALAB_API_KEY,
	IS_MCP_ENABLED
};
